import Logger from "@/utility/logger";

export const insertImage = async (base64Image: string) => {
  await Word.run(async (context) => {
    // Get the selection
    const range = context.document.getSelection();

    // Insert the image at the selection as an inline picture
    const image: Word.InlinePicture = range.insertInlinePictureFromBase64(base64Image, Word.InsertLocation.replace);

    // Optionally set size
    image.height = 150; // pixels
    image.width = 150;

    // Load properties if you want to use them
    image.load("height,width");
    await context.sync();

    Logger.debug(`Inserted image with size: ${image.width}x${image.height}`);
  });
};
